import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { isTenantAdmin } from '../../models/enums/user-role.enum';

/** Owner-only routes: staff land on the Forbidden page instead of a broken screen. */
export const tenantAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentProfile$.pipe(
    take(1),
    map((profile) =>
      profile && isTenantAdmin(profile.role) ? true : router.createUrlTree(['/forbidden']),
    ),
  );
};
